/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var ProjectDiagramIcon = createIcon({
  name: 'ProjectDiagramIcon',
  height: 512,
  width: 640,
  svgPath: 'M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default ProjectDiagramIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/project-diagram-icon.js
// module id = 866
// module chunks = 0